<template>
  <!-- VERTICAL LAYOUT WITH ICON-->
    <vx-card>
        <!-- <form> -->
            <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full mt-5">
                    <vs-input tabindex=1 class="w-full" icon-pack="feather" icon="icon-user" name="name" icon-no-border label="First Name" v-model="user.first_name" v-validate="'required'"/>
                    <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                    <vs-input tabindex=2 class="w-full" icon-pack="feather" icon="icon-user" icon-no-border label="Last Name" v-model="user.last_name" />		
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                    <vs-input tabindex=9 disabled type="email" class="w-full" icon-pack="feather" icon="icon-mail" icon-no-border label="Email" v-model="user.email" />
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                    <vs-input tabindex=3 class="w-full" icon-pack="feather" icon="icon-layers" icon-no-border label="Company" v-model="user.company" />
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                    <vs-input tabindex=4 type="password" class="w-full" icon-pack="feather" icon="icon-lock" icon-no-border label="Password" ref="password" name="password" v-model="user.password" v-validate="'min:8'" />
                    <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5">
                    <vs-input tabindex=5 type="password" class="w-full" icon-pack="feather" icon="icon-lock" name="confirm password" icon-no-border label="Confirm Password" v-model="user.confirm_password" v-validate="'min:8|confirmed:password'" />
                    <span class="text-danger text-sm" v-show="errors.has('confirm password')">{{ errors.first('confirm password') }}</span>
                </div>
                <div class="vx-col md:w-1/2 w-full mt-5 flex">
                    <vs-input tabindex=6 type="tel" class="w-4/5" name="phone" icon-pack="feather" icon="icon-smartphone" icon-no-border label="Phone (01xxxxxxxxx) or (201xxxxxxxxx) or (+201xxxxxxxxx)" v-model="user.mobile" v-validate="'min:11|max:15|required|numeric'"/>
                    <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
                    <vs-button v-if="numbers.length !== 2" class="w-1/5 ml-4 mt-5" radius color="primary" icon-pack="feather" icon="icon-plus" size="large" @click="addNumber()"></vs-button>
                </div>
                <div class="vx-col flex md:w-1/2 w-full mt-5" v-for="(mobileNumber, index) in numbers" :key="index">
                    <div>
                        <vs-input tabindex=6 type="tel" class="w-full" name="mobile phone" icon-pack="feather" icon="icon-smartphone" icon-no-border label="Phone (01xxxxxxxxx) or (201xxxxxxxxx) or (+201xxxxxxxxx)" v-model="mobileNumber.number" v-validate="'min:11|max:15|numeric'"/>
                        <span class="text-danger text-sm" v-show="errors.has('mobile phone')">{{ errors.first('mobile phone') }}</span>
                    </div>
                    <vs-button type="border" size="small" icon-pack="feather" icon="icon-x" class="w-1/5 ml-4 mt-6" @click="removeNumber(index)"> </vs-button>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col w-full">
                    <vs-button tabindex=7 class="mr-3 mb-2" @click.prevent="saveRequest($vs)">Save</vs-button>
                    <vs-button tabindex=8 color="warning" type="border" class="mb-2" @click="resetFeilds()">Cancel</vs-button>
                </div>
            </div>
        <!-- </form> -->
    </vx-card>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
import { sendRequest } from "../utils/requestHelpers";
export default {
  data() {
    return {
        user: {
            first_name: "",
            last_name: "",
            email: "",
            company: "",
            phone: "",
            password: "",
            confirm_password: "",
            additional_mobiles: []
        },
        numbers: [],
        userUUID: this.$store.getters.getUserId,
        };
    },
    methods: {
        removeNumber (index) {
            this.numbers.splice(index, 1)
        },
        resetFeilds(){
            this.user.first_name = "";
            this.user.last_name = "";
            this.user.company = "";
            this.user.mobile = "";
            this.user.additional_mobiles = [];
            this.numbers = [];
            this.user.password = "";
            this.user.confirm_password = "";
            delete this.user.password;
            delete this.user.confirm_password;
        },
        addNumber () {
            this.numbers.push({
                number: ''
            })
        },
        saveRequest(item) {
            let flage=true
            if(this.user.password == "" || this.user.password == undefined) {
                delete this.user.password;
                delete this.user.confirm_password;
            } else if (this.user.confirm_password == "" || this.user.confirm_password == undefined) {
                item.notify({
                        title: 'Error',
                        position: 'top-right',
                        text: 'Password and Confirm password mismatch',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    }
                )
                flage = false;
            }
            if (flage) {
                this.$validator.validateAll().then(result => {
                    if(result) {
                        this.user.additional_mobiles = []
                        this.numbers.forEach(element => {
                            this.user.additional_mobiles.push(element.number)
                        })
                        var successCallback = () => {
                            item.notify({
                                title: 'Success',
                                position: 'top-right',
                                text: 'Profile Updated Successfully.',
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-check'})
                            this.user.password = "";
                            this.user.confirm_password = "";
                            delete this.user.password;
                            delete this.user.confirm_password;
                        };
                        sendRequest('patch', 'users/' +  this.userUUID + '/', this.user, successCallback, null, this);
                    }
                })
            }
        },
    },
    created(){
        var successCallback = response => {
            this.user = response.data;
            this.user.additional_mobiles.forEach(element => {
                this.numbers.push({
                    number: element
                })
            })
        };
        sendRequest('get', 'users/' +  this.userUUID + '/', null, successCallback, null, this);
    },
}
</script>
